import { z } from "zod";

export const ASSISTANT_VOICE_ENTITY_REF_MAX = 24;
export const ASSISTANT_VOICE_ENTITY_HEADER_MAX_BYTES = 4 * 1024;
export const ASSISTANT_VOICE_AUDIO_MAX_BYTES = 5 * 1024 * 1024;
export const ASSISTANT_VOICE_MAX_RECORD_SECONDS = 90;

export const AssistantVoiceEntityKindSchema = z.enum(["customer", "supplier", "product", "sales_order", "purchase_order"]);
export type AssistantVoiceEntityKind = z.infer<typeof AssistantVoiceEntityKindSchema>;

export const AssistantVoiceEntityRefSchema = z
  .object({
    kind: AssistantVoiceEntityKindSchema,
    id: z.string().uuid(),
  })
  .strict();
export type AssistantVoiceEntityRef = z.infer<typeof AssistantVoiceEntityRefSchema>;

export const AssistantVoiceEntityRefsSchema = z.array(AssistantVoiceEntityRefSchema).max(ASSISTANT_VOICE_ENTITY_REF_MAX);
